export enum LongShiftPreferenceRating {
  VERY_UNIMPORTANT = 1,
  UNIMPORTANT = 2,
  NEUTRAL = 3,
  IMPORTANT = 4,
  VERY_IMPORTANT = 5,
}
